
import { Button, Container, LinearProgress } from '@mui/material'
import { withSnackbar } from 'notistack'
import React from 'react'
import { withRouter } from "react-router-dom"
import SocketIO from '../socketio'

class GuestLoginRedirect extends React.Component {
    socket = null

    async componentDidMount() {
        this.socket = new SocketIO()

        this.unbindConnect = this.socket.on('connect', this.handleConnect)
    }

    componentWillUnmount() {
        this.unbindConnect()

        this.socket.disconnect()
    }

    initialFetch = async () => {
        try {
            let { fileset, storeId, url } = this.props.match.params

            await this.socket.send('loginAsGuest', { step: 'loginFromWrapper' })

            this.props.history.push(`/${fileset}/s${storeId}/${url || ''}${window.location.search}`)

        } catch (err) {
            this.showError(err)
        }
    }

    handleConnect = () => {
        this.initialFetch()
    }

    showMessage = (msg, options) => {
        this.props.enqueueSnackbar(msg, {
            autoHideDuration: 3000,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'center',
            },
            ...options,
        })
    }

    showError = (err, options) => {
        this.showMessage(err.message || err, {
            variant: 'error',
            persist: true,
            style: { whiteSpace: 'pre-line' },
            // eslint-disable-next-line react/display-name
            action: (key) => <Button onClick={() => { this.props.closeSnackbar(key) }}>Dismiss</Button>,
            ...options,
        })
    }

    closeSnackbar = this.props.closeSnackbar

    render() {
        return (
            <Container maxWidth="xs" sx={{ py: 10 }}>
                <LinearProgress />
            </Container>
        )
    }
}

export default withRouter(withSnackbar(GuestLoginRedirect))
